export var BridgeReady;
(function (BridgeReady) {
  BridgeReady["READY"] = "ready";
  BridgeReady["LOADED"] = "loaded";
})(BridgeReady || (BridgeReady = {}));
export var platformType;
(function (platformType) {
  platformType["web"] = "web";
  platformType["mpWeb"] = "mp_web";
  platformType["mp"] = "mp";
})(platformType || (platformType = {}));
export var detectType;
(function (detectType) {
  detectType["ua"] = "ua";
  detectType["app"] = "app";
})(detectType || (detectType = {}));
export var clientName;
(function (clientName) {
  clientName["mpAe"] = "mp_ae";
  clientName["mpAlipay"] = "mp_alipay";
  clientName["mpAlipayHk"] = "mp_alipay_hk";
  clientName["mpAlipayPlus"] = "mp_alipay_plus";
  clientName["mpAlipayVn"] = "mp_alipay_vn";
  clientName["mpDana"] = "mp_dana";
  clientName["mpGcash"] = "mp_gcash";
  clientName["mpLazada"] = "mp_lazada";
  clientName["mpTaobao"] = "mp_taobao";
  clientName["mpTmall"] = "mp_tmall";
  clientName["mpTmn"] = "mp_tmn";
  clientName["mpTngd"] = "mp_tngd";
  clientName["mpWebAlipay"] = "mp_web_alipay";
  clientName["mpWebAlipayPlus"] = "mp_web_alipay_plus";
  clientName["webAe"] = "web_ae";
  clientName["webAlipay"] = "web_alipay";
  clientName["webAlipayHk"] = "web_alipay_hk";
  clientName["webAlipayMo"] = "web_alipay_mo";
  clientName["webAlipayPlus"] = "web_alipay_plus";
  clientName["webAlipayVn"] = "web_alipay_vn";
  clientName["webDaraz"] = "web_daraz";
  clientName["webH5"] = "web_h5";
  clientName["webKkp"] = "web_kkp";
  clientName["webLazada"] = "web_lazada";
  clientName["webTaobao"] = "web_taobao";
  clientName["webTaobaoOverseas"] = "web_taobao_overseas";
})(clientName || (clientName = {}));
export var ApiCallStage;
(function (ApiCallStage) {
  ApiCallStage["REQUEST"] = "REQUEST";
  ApiCallStage["MODIFIED_REQUEST"] = "MODIFIED_REQUEST";
  ApiCallStage["RESPONSE"] = "RESPONSE";
  ApiCallStage["MODIFIED_RESPONSE"] = "MODIFIED_RESPONSE";
  ApiCallStage["NOT_FOUND"] = "NOT_FOUND";
})(ApiCallStage || (ApiCallStage = {}));